<template>
  <div data-component-group="auth-form" data-component="join-account">
    <Form
      :title="$t('views_join_account_title')"
      :second-title="$t('views_join_account_second_title')"
      :subtitle="
        emailDomain !== ''
          ? $t('views_join_account_subtitle').replace(
            '{0}',
            '<strong>@' + emailDomain + '</strong>',
          )
          : ''
      "
    >
      <ul v-if="businesses.length > 0" class="business-list">
        <li
          v-for="business in businesses"
          :key="business.name"
          class="business"
        >
          <span class="business-name">
            {{ business.name }}
          </span>
        </li>
      </ul>

      <div class="note">
        <p>
          To join your company account, please reach out to your business administrator for access.
        </p>
      </div>

      <div class="note">
        <p>
          <label>
            {{ $t('views_join_account_note_before') }}<v-btn variant="text" :ripple="false" @click="onReenterAddress">{{ $t('views_join_account_action') }}</v-btn>{{ $t('views_join_account_note_after') }}
          </label>
        </p>
      </div>
    </Form>
  </div>
</template>

<script>
  import Form from '../Form';
  import router from '../../../router';
  import { isUndef } from '../../../utils';

  export default {
    components: {
      Form,
    },
    data: () => ({
      businesses: [],
      emailDomain: '',
      hasSentRequest: false,
    }),
    created() {
      // $watch needs a callback; passing only a source fn made Vue read
      // `callback.handler` off undefined and throw on every mount. Watch the
      // user getter and run the side effects in the callback (immediate keeps
      // the original run-on-created behavior).
      this.$watch(
        () => this.$store.getters['auth/user'],
        (user) => {
          if (isUndef(user)) return;

          this.watchUser(user);

          if (!this.hasSentRequest && !isUndef(user.business_id)) {
            this.hasSentRequest = true;
          }
        },
        { immediate: true },
      );
    },
    methods: {
      onReenterAddress() {
        router.replace({ name: 'login' });
      },
      watchUser(user) {
        const { emailDomain, businesses } = user;

        if (this.emailDomain !== emailDomain) {
          this.emailDomain = emailDomain;
          this.businesses = businesses;
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
@use 'sass:map';
@use '../../../assets/styles/theme' as *;

[data-component-group='auth-form'] {
  &[data-component='join-account'] {
    width: 40%;

    [data-component='form'] {
      width: 44%;
      margin: 0 auto;
      padding: 21.4vh 0 100px;
    }

    .business-list {
      list-style-type: none;
      padding: 0;
      margin: 0 0 30px 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;

      .business {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px $spacing-sm;
        margin: 0 0 10px 0;
        border-radius: $border-radius;
        border: 1px solid map.get($colors, grey, lighten-2);
        background-color: map.get($colors, grey, lighten-5);

        &:last-child {
          margin: 0;
        }

        .business-name {
          font-size: $text-size-md;
          font-weight: bold;
        }
      }
    }

    .note {
      p {
        font-size: $text-size-sm;
      }

      .v-btn {
        height: auto;
        min-height: auto;
        display: inline-block;
        padding: 0;
        margin: 0;
        font-size: $text-size-sm;
        text-transform: none;
        vertical-align: top;
        text-decoration: none;

        &:before {
          background-color: transparent !important;
        }
      }
    }
  }
}
</style>
